import React from 'react';
import useStyles from './bodyContainer.styles';

function BodyContainer({ children }) {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <div className={styles.children}>
        {children}
      </div>
    </div>
  );
}

export default BodyContainer;
